import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BLACK, WHITE, BG_GRAY, TEXT_GRAY, SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../../styles/variables.style';

const MOBILE_CELL_SIZE = 250;

export const Wrapper = styled.section`
  margin: 0 auto;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  overflow: hidden;
  padding: 40px ${MOBILE_PADDING}px;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  color: ${TEXT_GRAY.COMMON_5};
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 3em;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin: 0 0 7em;
  `};
`;

export const DescriptionContainer = styled.div`
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  padding: 0 ${MOBILE_PADDING}px;

  ${media.tabletL`
    flex-direction: row;
    padding: 0;
    margin-bottom: 90px;
  `};
`;

export const DescriptionWrapper = styled.div`
  margin-top: 15px;

  ${media.tabletL`
    margin-top: 0;
    padding-right: 100px;
    width: 50%;
    &.full-width {
      width: 100%;
      padding-right: 0;
      > p {
        width: 100%;
        padding-right: 0;
      }
    }
  `};
`;

export const Description = styled.p`
  color: ${BLACK};
  margin: 0;

  ${media.tabletL`
    width: 80%;
  `};

  h1,
  h2,
  h3,
  p {
    &:first-child {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 22px;
  }

  h3 {
    font-size: 20px;
  }

  p {
    font-size: 18px;
    line-height: 1.39;
    letter-spacing: 0.1px;
    white-space: pre-line;
  }

  a {
    text-decoration: underline;
  }
`;

export const TopicsWrapper = styled.div`
  display: none;

  ${media.tabletL`
    display: flex;
    justify-content: center;
  `};
`;

export const TopicWrapper = styled.div`
  flex: 1 1 0;
  padding-left: ${MOBILE_PADDING}px;

  ${media.tabletL`
    max-width: calc(100% / 3);
    padding: 0 10px;
    width: 100%;
  `};
`;

export const DescriptionImageWrapper = styled.div`
  height: fit-content;
  order: -1;

  ${media.tabletL`
    order: 0;
    width: 50%;
  `};
`;

export const ImageWrapper = styled.div`
  width: 100%;
`;

export const TopicTitle = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: 0.1px;
  margin: 20px 0 0;
`;

export const TopicDescription = styled.div`
  margin: 20px 0 0;

  h1,
  h2,
  h3,
  p {
    &:first-child {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 22px;
  }

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 18px;
  }

  p {
    font-size: 16px;
    line-height: 1.25;
    letter-spacing: 0.1px;
    white-space: pre-line;
  }
`;

export const SliderWrapper = styled.div`
  display: block;
  width: ${MOBILE_CELL_SIZE}px;

  & > div > div {
    width: ${MOBILE_CELL_SIZE}px;
    overflow: visible !important;
  }

  ${media.tabletL`
    display: none;
  `};
`;

export const ColumnContainer = styled.div`
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  padding: ${MOBILE_PADDING}px;
  border: 1px solid #ccc;
  box-sizing: border-box;

  ${media.tabletL`
    flex-direction: row;
    padding: 50px;
    margin-top: 80px;
  `};
`;

export const ColumnWrapper = styled.div`
  flex: 1 1 0;

  > p {
    width: 100%;
    > p:last-child {
      margin-bottom: 0;
    }
  }

  ${media.tabletL`
    max-width: calc(100% / 2);
    margin-right: 70px;
    width: 100%;
  `};
`;

export const ColumnImageWrapper = styled.div`
  height: fit-content;
  order: -1;
  margin-bottom: 30px;

  ${media.tabletL`
    order: 0;
    width: 50%;
    margin-bottom: 0;
  `};
`;

export const ColumnTitle = styled.div`
  color: ${BLACK};
  font-size: 16px;
  margin-bottom: 10px;
`;

export const ColumnSubTitle = styled.div`
  color: ${BLACK};
  font-size: 24px;
  margin-bottom: 30px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 40px auto 0;

  .button {
    width: 220px;
    align-items: center;
    background-color: ${BLACK};
    color: ${WHITE};
    cursor: pointer;
    display: flex;
    height: 64px;
    justify-content: center;
    margin-right: 10px;
    margin-left: 10px;
    ${media.tabletL`
      width: 320px;
    `};
  }

  ${media.tabletL`
    margin-top: 80px;
  `};
`;

export const Button = styled.div`
  width: 220px;
  align-items: center;
  background-color: ${BLACK};
  color: ${WHITE};
  cursor: pointer;
  display: flex;
  height: 64px;
  justify-content: center;
  margin-right: 10px;
  margin-left: 10px;
  ${media.tabletL`
    width: 320px;
  `};
`;

export const OneImageContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 50px;
  padding-top: 50px;

  ${media.tabletL`
    padding: 0 30px;
    margin-top: 80px;
    margin-bottom: 80px;
  `};

  img {
    max-width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/RangePage/RangeEditorial/RangeEditorial.style.js